import React from 'react';
import { DatePicker as AntdDatePicker } from 'antd';
import { joinAriaIds, useWxbFieldIds } from '../_internal/fieldA11y';
import { resolvePopupContainer } from '../_internal/portalContainer';
import './RangePicker.css';

const { RangePicker: AntdRangePicker } = AntdDatePicker;

export type WxbRangePickerProps = React.ComponentProps<typeof AntdRangePicker> & {
  label?: string;
  error?: string;
};

export const WxbRangePicker: React.FC<WxbRangePickerProps> = ({
  label,
  error,
  className = '',
  id,
  'aria-describedby': ariaDescribedBy,
  'aria-invalid': ariaInvalid,
  // 全屏下面板就近渲染到触发器内;非全屏保持 antd 默认(body)。
  getPopupContainer = resolvePopupContainer,
  ...props
}) => {
  const { controlId, labelId, feedbackId } = useWxbFieldIds();
  const describedBy = joinAriaIds(ariaDescribedBy, error ? feedbackId : undefined);

  return (
    <div className="wxb-field">
      {label && <span id={labelId} className="wxb-label">{label}</span>}
      <div
        id={controlId}
        role="group"
        aria-labelledby={label ? labelId : undefined}
        aria-describedby={describedBy}
      >
        <AntdRangePicker
          {...(props as any)}
          id={id}
          className={`wxb-rangepicker ${error ? 'wxb-rp-error' : ''} ${className}`}
          popupClassName="wxb-datepicker-popup"
          getPopupContainer={getPopupContainer}
          aria-describedby={describedBy}
          aria-invalid={ariaInvalid ?? (Boolean(error) || undefined)}
          status={error ? 'error' : props.status}
        />
      </div>
      {error && <span id={feedbackId} className="wxb-help wxb-help-error" role="alert">{error}</span>}
    </div>
  );
};
